import { createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, TransitionGroup as _TransitionGroup, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/mp4/light-tour.mp4'
import _imports_1 from '@/assets/mp4/dark-tour.mp4'

const _withId = /*#__PURE__*/_withScopeId("data-v-05876fa5")

_pushScopeId("data-v-05876fa5")
const _hoisted_1 = { id: "previews" }
const _hoisted_2 = {
  id: "tour",
  class: "flex-center"
}
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "ed" }, [
  /*#__PURE__*/_createTextVNode(" e-Dnevnik "),
  /*#__PURE__*/_createVNode("span", { class: "plus" }, "Plus App"),
  /*#__PURE__*/_createTextVNode(" — Obilazak ")
], -1)
const _hoisted_4 = { id: "types" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode("div", _hoisted_4, [
        _createVNode("a", {
          class: ["card", { plus: _ctx.mode == 'light' }],
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.mode = 'light'))
        }, "Svijetli prikaz", 2),
        _createVNode("a", {
          class: ["card", { plus: _ctx.mode == 'dark' }],
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.mode = 'dark'))
        }, "Tamni prikaz", 2),
        _createVNode("a", {
          class: ["card", { plus: _ctx.mode == 'double' }],
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.mode = 'double'))
        }, "Dupli prikaz", 2),
        _createVNode("a", {
          class: ["card", { plus: _ctx.fast }],
          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.changeSpeed && _ctx.changeSpeed(...args)))
        }, "Brzina " + _toDisplayString(_ctx.fast ? "x2" : "x1"), 3)
      ])
    ]),
    _createVNode("div", {
      id: "videos",
      class: ["flex-center", { double: _ctx.mode == 'double' }]
    }, [
      _createVNode(_TransitionGroup, { name: "opacity" }, {
        default: _withId(() => [
          _withDirectives(_createVNode("video", {
            ref: "light",
            src: _imports_0,
            muted: "",
            autoplay: "",
            controls: "",
            loop: "",
            onTimeupdate: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.timeUpdated && _ctx.timeUpdated(...args))),
            onPlay: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.timeUpdated && _ctx.timeUpdated(...args))),
            onPause: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.timeUpdated && _ctx.timeUpdated(...args))),
            key: "1"
          }, null, 544), [
            [_vShow, _ctx.mode == 'light' || _ctx.mode == 'double']
          ]),
          _withDirectives(_createVNode("video", {
            ref: "dark",
            src: _imports_1,
            muted: "",
            autoplay: "",
            controls: "",
            loop: "",
            onTimeupdate: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.timeUpdated && _ctx.timeUpdated(...args))),
            onPlay: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.timeUpdated && _ctx.timeUpdated(...args))),
            onPause: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.timeUpdated && _ctx.timeUpdated(...args))),
            key: "2"
          }, null, 544), [
            [_vShow, _ctx.mode == 'dark' || _ctx.mode == 'double']
          ])
        ]),
        _: 1
      })
    ], 2)
  ]))
})